import driversAPI from "../../API/endpoints/drivers";
import { sliceActions } from "../drivers-slice";

export const fetch = () => {
  return async (dispatch) => {
    try {
      const response = await driversAPI.get();
      dispatch(sliceActions.populateData(response.data));
      dispatch(sliceActions.populateOptions(response.data));
    } catch (error) {
      console.log(error);
    }
  };
};

export const create = (payload) => {
  return async (dispatch) => {
    try {
      await driversAPI.create(payload);
      dispatch(fetch());
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
};

export const remove = (id) => {
  return async (dispatch) => {
    try {
      await driversAPI.delete(id);
      dispatch(fetch());
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
};

export const activate = (id) => {
  return async (dispatch) => {
    try {
      await driversAPI.activate(id);
      dispatch(fetch());
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
};

export const deactivate = (id) => {
  return async (dispatch) => {
    try {
      await driversAPI.deactivate(id);
      dispatch(fetch());
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
};
